// src/pages/AccessExpiredPage.js
import React from "react";
import { Link } from "react-router-dom";
import styles from "../css/Login.module.css";
import { FiLock, FiArrowLeft, FiClock, FiAlertTriangle } from "react-icons/fi";

const AccessExpiredPage = () => {
  return (
    <div className={styles.pageContainer}>
      <div className={styles.authCard}>
        <div className={styles.header}>
          <FiLock
            size={40}
            color="#ef4444"
            style={{ marginBottom: "1rem" }}
          />
          <h2>Acceso Expirado</h2>
          <p>
            Su acceso al sistema ha expirado. Para renovar su acceso, por favor contacte al administrador.
          </p>
        </div>

        {/* Sección de información de contacto */}
        <div
          style={{
            background: "#fef2f2",
            padding: "1.5rem",
            borderRadius: "8px",
            border: "1px solid #fecaca",
            marginBottom: "2rem",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}>
            <FiAlertTriangle 
              size={20} 
              color="#dc2626" 
              style={{ marginRight: "0.5rem" }}
            />
            <p
              style={{
                margin: 0,
                fontWeight: "bold",
                fontSize: "1.1rem",
                color: "#dc2626",
              }}
            >
              Acceso Bloqueado
            </p>
          </div>
          
          <p
            style={{
              margin: "0 0 0.5rem 0",
              fontWeight: "bold",
              fontSize: "1rem",
              color: "#374151",
            }}
          >
            Daniel Medina - Administrador
          </p>
          <a
            href="mailto:help@danielmedina.io"
            className={styles.link}
            style={{ fontSize: "1rem", color: "#dc2626" }}
          >
            📧 help@danielmedina.io
          </a>
          <p
            style={{
              fontSize: "0.9rem",
              color: "#6b7280",
              marginTop: "1rem",
              marginBottom: 0,
            }}
          >
            Te ayudaremos a renovar el acceso a tu cuenta.
          </p>
        </div>

        {/* Información adicional */}
        <div
          style={{
            background: "#f9fafb",
            padding: "1rem",
            borderRadius: "8px",
            border: "1px solid #e5e7eb",
            marginBottom: "2rem",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", marginBottom: "0.5rem" }}>
            <FiClock size={16} color="#6b7280" style={{ marginRight: "0.5rem" }} />
            <p style={{ margin: 0, fontSize: "0.9rem", color: "#6b7280" }}>
              ¿Por qué mi acceso expiró?
            </p>
          </div>
          <p style={{ margin: 0, fontSize: "0.85rem", color: "#6b7280", lineHeight: "1.4" }}>
            Los accesos tienen una fecha de expiración por seguridad. 
            Contacta al administrador para renovar tu acceso.
          </p>
        </div>

        {/* Botón para volver a la página de login */}
        <Link
          to="/login"
          className={styles.button}
          style={{ textDecoration: "none", width: "100%" }}
        >
          <FiArrowLeft />
          <span>Volver a Inicio de Sesión</span>
        </Link>
      </div>
    </div>
  );
};

export default AccessExpiredPage;
